import React, { ReactNode } from 'react';
import { useRoles } from 'src/provider/UserRoleProvider';
import BCNListDialogCommon from './BCNListDialogCommon';
import AddBcnPage from './BCNList/AddBcnPage';

type Props = Readonly<{
  BcnCameOnDeal: boolean;
  bcn_linking_level: string;
  branchCodes?: string[] | null;
  customerSetId: string;
  dealId: string;
  discountType?: string;
  generateQuote?: (selectedBcn: string[], disabled: boolean) => ReactNode;
  handleClose: () => void;
  isResolvedOnException: boolean;
  resellerAuth: string;
  resellerName: string;
  vendor_program_id?: string | number;
}>;

export default function ShowBCNListDialog(props: Props) {
  const { isCOGUser, isVBMUser } = useRoles();

  return (
    <BCNListDialogCommon
      {...props}
      AddBcnPageComponent={AddBcnPage}
      enablePagination={false}
      showBCNAction={isCOGUser || isVBMUser}
      showResolutionType={false}
    />
  );
}
